const getters = {
  scWorks: state => state.sc_works,
  scWork: state => state.sc_work,
  scWorkFilters: state => state.sc_work_filters,
  scWorkCollector: state => state.sc_work_collector,
}

export default getters;
